<div class="input" (click)="handleBackgroundClick($event)">
  <input
    #inputField
    type="text"
    [ngModel]="formArray.controls[current].value"
    (ngModelChange)="updateValue($event)"
    [placeholder]="getPlaceholder()"
    (keyup.enter)="onAdd()"
    (blur)="onBlur()"
    (focus)="onFocus()"
    [ngClass]="{
      icon: isIconDisplay,
      'icon-focus': isFocus,
      selected: isSelected,
    }"
    (input)="onInput($event)"
  />
</div>

<div class="list-container" *ngIf="isOpen">
  <div class="list" *ngFor="let item of formArray.controls; let i = index">
    <p
      (click)="editItem(i)"
      *ngIf="i !== 0 && item.value !== ''"
      [class.selected]="isSelected && current === i"
    >
      {{ item.value }}
    </p>
  </div>
</div>
